module.exports = __webpack_public_path__ + "static/img/evaluate.b910898.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/teacher-comment/evaluate.png
// module id = yoga
// module chunks = 1